import styled from '@emotion/styled';
import Typography from 'components/Typography/Typography';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const Container = styled.div`
  display: flex;
  max-width: 100%;
  flex: 1;
  overflow: hidden;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${pxToEm(8)};
`;

export const Title = styled(Typography)`
  color: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Badge = styled.div`
  background: ${palette.success.main};
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  min-width: 12px;
  padding: 0 2px;
  color: ${palette.common.white};
  margin-left: 6px;
  margin-right: 0;
`;
